import { NAVIGATION, SITE_PAGES } from 'Config';
import withRouter from 'Lib/hoc/withRouter';
import { isUserAuthorized } from 'Util';
import SideNavMenu from './SideNavMenu';

let SideTabNavWithRouter = withRouter(SideNavMenu);

const BOSSideTabNav = () => {
  const getAuthorizedPage = (page) => {
    return isUserAuthorized(page.requiredAuth) ? page : page.redirect;
  };

  let upperMenuItems = NAVIGATION.sideNavbarLinks.reduce((linkArray, page) => {
    let pageToInclude = getAuthorizedPage(page);
    if (pageToInclude) {
      linkArray.push({
        ...pageToInclude,
        ...(pageToInclude.menuItems && {
          menuItems: pageToInclude.menuItems.reduce((subLinkArray, subpage) => {
            let pageToInclude = getAuthorizedPage(subpage);
            if (pageToInclude) {
              subLinkArray.push(pageToInclude);
            }
            return subLinkArray;
          }, []),
        }),
      });
    }
    return linkArray;
  }, []);

  let lowerMenuItems = NAVIGATION.lowerSideNavbarLinks.reduce(
    (linkArray, page) => {
      let pageToInclude = getAuthorizedPage(page);
      if (pageToInclude) {
        linkArray.push(pageToInclude);
      }
      return linkArray;
    },
    [],
  );

  return (
    (upperMenuItems?.length > 0 || lowerMenuItems?.length > 0) && (
      <SideTabNavWithRouter
        upperMenuItems={upperMenuItems}
        lowerMenuItems={lowerMenuItems}
        defaultExpandedMenuItems={[
          SITE_PAGES.ORDER_LANDING.tabId,
          SITE_PAGES.TRANSACTION_LANDING.tabId,
        ]}
      />
    )
  );
};

export default BOSSideTabNav;
